import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Mention } from '../../models/mention';

@Component({
    selector: 'agpr-mention-translation-tabs',
    templateUrl: './mention-translation-tabs.component.html',
    styleUrls: ['./mention-translation-tabs.component.scss'],
    standalone: false
})
export class MentionTranslationTabsComponent {
    @Input() selectedTabIndex: number = 0;
    @Input() mention: Mention;
    @Input() tabsHeadingLevel: number = 3;

    @Output() tabChanged: EventEmitter<number> = new EventEmitter<number>();

    constructor() {}

    tabIndexChange(index: number): void {
        this.selectedTabIndex = index;
        this.tabChanged.emit(this.selectedTabIndex);
    }
}
